module.exports = __webpack_public_path__ + "img/icons-jcgl-venues.1efaad99.png";